module.exports = __webpack_public_path__ + "img/home_logo_img.457affef.png";